import useCurrentUrl from '@repo/ui/src/hooks/useCurrentUrl';
import axios, { AxiosRequestConfig } from 'axios';
import React from 'react';
import useSWRInfinite from 'swr/infinite';

interface SearchData {
  page: number;
  nbPages: number;
  nbHits: number;
  results: Array<any>;
}
interface Key extends AxiosRequestConfig {
  productGeo: string;
}
const fetcher = async ({ productGeo, ...props }: Key) => {
  const { data } = await axios(props);
  const results =
    data.results?.filter((item: any) => {
      if (item?.productData?.productGeos) {
        return item.productData.productGeos.find(
          ({ geos }: { geos: string }) => geos === productGeo,
        );
      }
      return item;
    }) ?? [];
  return {
    ...data,
    results,
  } as SearchData;
};

interface Props {
  searchTerm: string;
  searchType: string;
  initialSize?: number;
}

export const useSearch = ({ searchTerm, searchType, initialSize = 1 }: Props) => {
  const { locale = 'en-US', productGeo } = useCurrentUrl();
  const { data: dataArray, ...rest } = useSWRInfinite(
    (page) => ({
      url: '/api/search/generalSearch',
      method: 'GET',
      params: {
        searchTerm,
        searchType,
        page,
        lang: locale,
      },
      productGeo,
    }),
    fetcher,
    {
      initialSize,
      parallel: true,
    },
  );
  const data = React.useMemo(() => {
    const results = dataArray?.map((item) => item.results).flat() ?? [];
    const last = dataArray?.[dataArray?.length - 1];
    return {
      page: 0,
      nbPages: 0,
      nbHits: 0,
      ...last,
      results,
    };
  }, [dataArray]);

  return { data, ...rest };
};
